import { applyMiddleware, combineReducers, compose,createStore,} from 'redux';
import {PostsReducer, toggleMenu} from './reducers/PostsReducer';
import thunk from 'redux-thunk';
import { AuthReducer } from './reducers/AuthReducer';
import { UsersReducer } from './reducers/UsersReducer';
import { RolesReducer } from './reducers/RolesReducer';
import { PoliciesReducer } from './reducers/PoliciesReducer';
import { PropertyTypesReducer } from './reducers/PropertyTypesReducer';
import { ListingTypesReducer } from './reducers/ListingTypesReducer';
import { OwnershipTypesReducer } from './reducers/OwnershipTypesReducer';
import { FurnishingStatusReducer } from './reducers/FurnishingStatusReducer';
import { FacingDirectionReducer } from './reducers/FacingDirectionReducer';
import { AvailabilityStatusReducer } from './reducers/AvailabilityStatusReducer';
import { AmenityReducer } from './reducers/AmenityReducer';
import { FeatureReducer } from './reducers/FeatureReducer';
import { PriceUnitReducer } from './reducers/PriceUnitReducer';
import { PropertyReducer } from './reducers/PropertyReducer';
import { CustomerReducer } from './reducers/CustomerReducer';
import { PropertyVerificationReducer } from './reducers/PropertyVerificationReducer';
import { PurchasePlanReducer } from './reducers/PurchasePlanReducer';
import { SubscriptionReducer } from './reducers/SubscriptionReducer';
import { PaymentReducer } from './reducers/PaymentReducer';
import { BankReducer } from './reducers/BankReducer';
import { PropertyBankVerificationReducer } from './reducers/PropertyBankVerificationReducer';
import { ReportReducer } from './reducers/ReportReducer';
import { SupportReducer } from './reducers/SupportReducer';
import { NotificationReducer } from './reducers/NotificationReducer';
import todoReducers from './reducers/Reducers';
const middleware = applyMiddleware(thunk);

const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const reducers = combineReducers({
    sideMenu: toggleMenu,
    posts: PostsReducer,
    users: UsersReducer,
    roles: RolesReducer,
    policies: PoliciesReducer,
    PropertyTypes: PropertyTypesReducer,
    listingTypes: ListingTypesReducer,
    ownershipTypes: OwnershipTypesReducer,
    furnishingStatus: FurnishingStatusReducer,
    facingDirection: FacingDirectionReducer,
    availabilityStatus: AvailabilityStatusReducer,
    amenity: AmenityReducer,
    priceUnit: PriceUnitReducer,
    feature: FeatureReducer,
    property: PropertyReducer,
    customer: CustomerReducer,
    propertyVerification: PropertyVerificationReducer,
    purchasePlan: PurchasePlanReducer,
    subscription: SubscriptionReducer,
    payment: PaymentReducer,
    bank: BankReducer,
    propertyBankVerification: PropertyBankVerificationReducer,
    report: ReportReducer,
    notification: NotificationReducer,
    support: SupportReducer,
    auth: AuthReducer,
    todoReducers,
	
});

export const store = createStore(reducers,  composeEnhancers(middleware));
